import React, { useContext, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { ConfigContext } from '../../Context/ConfigContext'
import axios from 'axios'
import "../../Styles/AutoComplete.css"
import { formatSlug } from '../../Utils/Helper'
import { checkTokenExpiration } from '../../Utils/CheckTokenExpiry'

const MobileNavigation = () => {

    const cartList = useSelector(state => state.Cart)
    const wishList = useSelector(state => state.Wishlist)
    const dispatch = useDispatch()
    const suggestionTimeoutRef = useRef(null);

    const [subTotalAmount, setSubTotalAmount] = useState(0)
    const [category_id, setcategory_id] = useState(null);
    const [searchInputValue, setSearchInputValue] = useState('')
    const [suggestionList, setSuggestionList] = useState([])
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [activeMenu, setActiveMenu] = useState(null);
    const { currency, setCurrency, setCurrencyValue, apiURL } = useContext(ConfigContext)
    const [data, setData] = useState([]);
    const navigate = useNavigate()

    const token = checkTokenExpiration();
    const path = useLocation();

    const toggleMenu = (id, e) => {
        e.preventDefault();
        setActiveMenu(activeMenu === id ? null : id);
    };

    const GetProductSearchList = async () => {
        try {
            const response = await axios.get(`${apiURL}Home/GetProductSearchList`, { params: { category_id: category_id } });
            if (response.data.success) {
                setData(response.data.data);
                setSuggestionList(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    const handleProductDetails = (item) => {
        if (item) {
            const newPath = `/GetProductDetails/${formatSlug(item.product_title)}=${item.product_id}`;
            if (path.pathname !== newPath) {
                navigate(newPath);
            }
        }
    };

    const calculatesubTotalAmount = () => {
        const subTotal = cartList.reduce((acc, cur) => acc + cur.quantity * cur.product_variant_sale_price, 0);
        setSubTotalAmount(subTotal);
    };

    const handleSearchCategories = (value) => {
        setSearchInputValue(value);
        if (value?.length > 0) {
            const filteredData = data.filter((item) =>
                item.product_title.toLowerCase().includes(value.toLowerCase())
            );
            setSuggestionList(filteredData);
            setShowSuggestions(true);
        } else {
            setShowSuggestions(false);
        }
    };

    const handleSuggestionClick = (product) => {
        setSearchInputValue(product.product_id)
        setSuggestionList([]);
        if (product) {
            const currentPath = path.pathname.includes("GetProductDetails");
            const newPath = currentPath
                ? `/ProductDetails/${formatSlug(product.product_title)}=${product.product_id}`
                : `/GetProductDetails/${formatSlug(product.product_title)}=${product.product_id}`;

            if (path.pathname !== newPath) {
                navigate(newPath);
            }
            closehome()
        }
        setShowSuggestions(false)
        setSearchInputValue("")
    }

    const handleBlur = () => {
        suggestionTimeoutRef.current = setTimeout(() => {
            setShowSuggestions(false);
        }, 200);
    };

    const handleFocus = () => {
        clearTimeout(suggestionTimeoutRef.current);
    };

    const handleChangeCurrency = (selectedCurrency) => {
        closehome();

        if (selectedCurrency === 'INR') {
            setCurrency('₹')
            setCurrencyValue('INR')
            localStorage.setItem('currency_label', '₹')
            localStorage.setItem('currency_value', 'INR')
        } else {
            setCurrencyValue('USD')
            setCurrency('$');
            localStorage.setItem('currency_label', '$')
            localStorage.setItem('currency_value', 'USD')
        }
        setTimeout(() => window.location.reload(), 100);
    }

    useEffect(() => {
        GetProductSearchList();
    }, [category_id]);

    useEffect(() => {
        calculatesubTotalAmount();
    }, [cartList]);

    const handleLogout = () => {
        localStorage.removeItem("customer_id");
        localStorage.removeItem("token");
        navigate('/');
    };

    const closehome = () => {
        document.getElementById('close-btn').click();
    }

    return (
        <>
            <div className="mobile-header-active mobile-header-wrapper-style">
                <div className="mobile-header-wrapper-inner">
                    <div className="mobile-header-top">
                        <div className="mobile-header-logo">
                            <Link to={'/'}><img src="/assets/imgs/logo/2.png" alt="logo" style={{ width: "150px" }} /></Link>
                        </div>
                        <div className="mobile-menu-close close-style-wrap close-style-position-inherit" id='close-btn'>
                            <button className="close-style search-close">
                                <i className="icon-top" />
                                <i className="icon-bottom" />
                            </button>
                        </div>
                    </div>
                    <div className="mobile-header-content-area">
                        <div className="mobile-search search-style-3 mobile-header-border">
                            <div className="search-container" style={{ position: 'relative' }}>
                                <form action="#">
                                    <input
                                        type="text"
                                        value={searchInputValue}
                                        onChange={(e) => handleSearchCategories(e.target.value)}
                                        placeholder="Search for product..."
                                        onBlur={handleBlur}
                                        onFocus={handleFocus}
                                        aria-autocomplete="list"
                                        aria-controls="autocomplete-list"
                                        style={{ border: "0", width: "100%" }}
                                    />
                                    {showSuggestions && (
                                        <div
                                            id="autocomplete-list"
                                            className="suggestions"
                                            style={{
                                                position: "absolute",
                                                top: "100%",
                                                left: 0,
                                                width: "100%",
                                                background: "#fff",
                                                border: "1px solid #ccc",
                                                zIndex: 1000
                                            }}
                                            onMouseDown={(e) => e.preventDefault()}
                                        >
                                            {suggestionList?.length ? (
                                                suggestionList.map((item, i) => (
                                                    <div
                                                        key={i}
                                                        onMouseDown={() => handleSuggestionClick(item)}
                                                        style={{
                                                            padding: "10px",
                                                            cursor: "pointer",
                                                            borderBottom: "1px solid #eee"
                                                        }}
                                                    >
                                                        {item.product_title}
                                                    </div>
                                                ))
                                            ) : (
                                                <div style={{ padding: "10px" }}>No suggestions found</div>
                                            )}
                                        </div>
                                    )}
                                    <button type="submit"><i className="fi-rs-search" /></button>
                                </form>
                            </div>
                        </div>
                        <div className="mobile-menu-wrap mobile-header-border">
                            <nav>
                                <ul className="mobile-menu font-heading">
                                    <li className="menu-item-has-children" style={{ display: "flex", alignItems: "center" }}>
                                        <i className="fa-solid fa-house" style={{ width: "20px", marginRight: "5px" }}></i>
                                        <Link to="/"><span className="lable ml-0" onClick={closehome}>Home</span></Link>
                                    </li>
                                    <li className="menu-item-has-children">
                                        <i className="fa-solid fa-address-book" style={{ width: "20px", marginRight: "5px" }}></i>
                                        <Link to="/Contact"><span className="lable ml-0" onClick={closehome}>Contact</span></Link>
                                    </li>
                                    {
                                        token ?
                                            <li className="menu-item-has-children" style={{ display: "flex", alignItems: "center" }}>
                                                <i class="fa-solid fa-user" style={{ width: "20px", marginRight: "5px" }}></i>
                                                <Link to="/MyAccount"><span className="lable ml-0" onClick={closehome}>Account</span></Link>
                                            </li>
                                            : ""
                                    }
                                    <li className="menu-item-has-children">
                                        <div style={{ cursor: "pointer" }}>
                                            <img
                                                style={{ marginRight: "5px" }}
                                                src={currency === "₹" ? "https://flagcdn.com/w40/in.png" : "https://flagcdn.com/w40/us.png"}
                                                width="20"
                                                alt="currency flag"
                                            />
                                            {currency === "₹" ? "INR" : "USD"}
                                        </div>
                                        <ul className="dropdown">
                                            <li>
                                                <div onClick={() => handleChangeCurrency("INR")} style={{ cursor: "pointer" }}>
                                                    <img src="https://flagcdn.com/w40/in.png" alt="INR" width="20" /> INR
                                                </div>
                                            </li>
                                            <li>
                                                <div onClick={() => handleChangeCurrency("USD")} style={{ cursor: "pointer" }}>
                                                    <img src="https://flagcdn.com/w40/us.png" alt="USD" width="20" /> USD
                                                </div>
                                            </li>
                                        </ul>
                                    </li>


                                </ul>
                            </nav>
                        </div>
                        <div className="mobile-header-info-wrap">
                            <div className="single-mobile-header-info">
                                <Link to={'/Contact'} onClick={closehome}><i className="fi-rs-marker" /> Our location </Link>
                            </div>
                            {
                                !token ?
                                    <div className="single-mobile-header-info">
                                        <Link to={'/Login'} onClick={closehome}><i className="fi-rs-user" />Log In / Sign Up </Link>
                                    </div>
                                    : ""
                            }
                            <div className="single-mobile-header-info">
                                <Link target='_blank' to={'https://www.instagram.com/crystalliveemporium?igsh=MXFud2p5OW40MDQ5Mg=='}><i class="fa-brands fa-instagram"></i> Instagram</Link>
                            </div>
                            <div className="single-mobile-header-info">
                                <Link target='_blank' to={'https://www.youtube.com/@stoneskill-d2k?sub_confirmation=1'}><i class="fa-brands fa-youtube"></i> Youtube</Link>
                            </div>
                            <div className="single-mobile-header-info">
                                <Link target='_blank' to={'https://www.facebook.com/share/1EhjmzYzQs/'}><i className="fa-brands fa-facebook" />Facebook</Link>
                            </div>
                        </div>
                        <div className="site-copyright">Copyright 2024 © DualSysco Research & Development. All rights reserved.</div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MobileNavigation